<span [countUp]="countUpValue" [reanimateOnClick]="false" [options]="countUpOptions"></span>
